/**
 * The date-and-time label the profile tabs have always shown, kept so moving a
 * tab's data source does not also change the look. Written in moment's tokens
 * rather than `dateformat`'s because the test setup replaces `dateformat` with
 * a constant, which would leave the label untestable;
 * `'dddd, mmmm dS, yyyy, h:MM:ss TT'` in `dateformat` renders the same string.
 */
export const PROFILE_DATE_TIME_FORMAT = 'dddd, MMMM Do, YYYY, h:mm:ss A';
